/**
 * Profile Page with Shared Sidebar
 */

import Sidebar from './Sidebar';
import ProfileSettings from './ProfileSettings';

export default function ProfilePage() {
  return (
    <div className="flex h-screen overflow-hidden bg-light-100">
      <Sidebar />
      <div className="flex-1 overflow-hidden">
        <ProfileSettings />
      </div>
    </div>
  );
}

